var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-spinner"},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line"}),_c('div',{staticClass:"spinner-line"}),_c('div',{staticClass:"spinner-line"}),_c('div',{staticClass:"spinner-circle"},[_vm._v("●")])])])
}]

export { render, staticRenderFns }